import { format, isEmptyValue } from "../util";
var required = function required(rule, value, source, errors, options, type) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || isEmptyValue(value, type || rule.type))) {
    errors.push(format(options.messages.required, rule.fullField));
  }
};
export default required;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rc-component/async-validator/es/rule/required.js
// module id = 677
// module chunks = 0